export default "__VITE_ASSET__DkhyotX___"